'use client'

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { MessageContext } from "@/context/messageContext";
import { messageListTypes } from "@/type/user";
import Pagenation from "@/components/common/pagenation";
import moment from "moment";
import ParsedHtmlContent from "@/components/etc/renderContent";
import api from "@/util/api";
import customAlert from "@/util/customAlert";
import { AuthContext } from "@/context/authContext";
import { useTranslations } from "next-intl";
import LocaleFormat from "@/components/etc/localeFormat";

export default function FloatMessages() {
    const { getUserDetail } = useContext(AuthContext)

    const { messageShow, 
            SetMessageShow, 
            messageType, 
            SetMessageType, 
            messageList, 
            totalCount, 
            page,
            setPage, 
            fetchData ,
            showSponMsg,
            setshowSponMsg,
            appPush

          } = useContext(MessageContext)

    const [otherShowIdx, setOtherShowIdx] = useState<number>()


    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    
    function allRemove(type:string){    
        if(totalCount == 0) {
            customAlert(a("InvalidMessage"), "warning")
            return false;
        }

        console.log("urls : ", `/api/${type}/message/delete/all/`)


        api(`/api/${type}/message/delete/all/`, { method: 'post'})
            .then(res=> res.json())
            .then(({status_code, message})=> {
                customAlert(message, status_code == 200 ? "success" : "warning")
                getUserDetail();
                fetchData(type, page);
            })
    }
    function allRead(type:string){        
        if(totalCount == 0) {
            customAlert(a("InvalidMessage"), "warning")
            return false;
        }
        api(`/api/${type}/message/read/all/`, { method: 'post'})
            .then(res=> res.json())
            .then(({status_code, message})=> {
                customAlert(message, status_code == 200 ? "success" : "warning")
                getUserDetail();
                fetchData(type, page);
            })
    }

    
    useEffect(() => {
        // console.log("hehe : ", showSponMsg, appPush)
        if(!appPush){
            if(messageShow) {
                fetchData("user", 1);
                setshowSponMsg(true)
            }else{
                getUserDetail();
            }
        }
    }, [messageShow])

    useEffect(() => {
        // console.log("■■■■■■■■■ MESSAGE ■■■■■■■■■")
        // console.log(`■■■     ${messageType}     ■■■`)
        // console.log("■■■■■■■■■ MESSAGE ■■■■■■■■■")
        // fetchData(messageType)
        // setPage(1)
    }, [messageType])
    
    return (
        <FloatDialog
            show={messageShow}
            setShow={SetMessageShow}
            onHide={()=> SetMessageType('user')}
            className="messages">

            <FloatDialog.Head>
                <div className="messages-header">
                    <p>{t("쪽지함")}</p>
                    <div className="active-btns">
                        <button className={`${messageType == 'user' ? "active":""}`}
                                onClick={()=>{SetMessageType('user'); }}>{t("스폰TV쪽지")}</button>
                        <button className={`${messageType == 'verified' ? "active":""}`} 
                                onClick={()=>{SetMessageType('verified');}}>{t("스폰업체쪽지")}</button>
                    </div>
                </div>
            </FloatDialog.Head>


            
            <FloatDialog.Body>
                <div className="messages-container">
                    <ul className="messages-list">

                        {   
                                messageList.length > 0?
                                messageList.map((li,_) => (
                                    <MessageListItem key={li.id} 
                                                     li={li} 
                                                     otherShowIdx={otherShowIdx} 
                                                     setOtherShowIdx={setOtherShowIdx}
                                                     showSponMsg={showSponMsg} />
                                ))
                                :
                                <li className="empty">{a("InvalidMessageList")}</li>
                        }
                    </ul>
                </div>
                <div className="active-btns flex flex_end m-t-10">
                    <button className="all-read"  
                            onClick={()=>{ allRead(messageType) }}>{t("전체읽음")}</button>
                    <button className="all-clear" 
                            onClick={()=>{ allRemove(messageType) }}>{t("전체삭제")}</button>
                </div>
                <Pagenation key={messageType} perPage={5} setPage={setPage} totalCount={totalCount} />
            </FloatDialog.Body>
        </FloatDialog>
    )
}

function MessageListItem({ li, otherShowIdx, setOtherShowIdx , showSponMsg}:
    {
        li: messageListTypes,
        otherShowIdx: number | undefined,
        setOtherShowIdx: Function,
        showSponMsg:boolean
    }) {
    const { MessageRead } = useContext(MessageContext)
    const [isShow, setShow] = useState<boolean>(false)
    const viewRef = useRef<HTMLDivElement>(null)

    const t = useTranslations("Text")

    useEffect(() => {
        if (otherShowIdx != li.id) {
            setShow(false)
        }
    }, [otherShowIdx])

    useEffect(() => {
        if (isShow) {
            MessageRead(li.id)
            setOtherShowIdx(li.id)
        }
        const el = viewRef.current;

        if (el) {
            if (isShow) {
                const scrollHeight = el.scrollHeight;
                el.style.height = scrollHeight + 'px';
            } else {
                el.style.height = '0px';
            }
        }
    }, [isShow])

    useEffect(()=> {
        // console.log("list : ", li.is_read)
    }, [li])
    return (
        <>
            <li onClick={e => setShow(!isShow)}>
                <div className="list">
                    <div className="title">{li.title} ({li.id})</div>
                    <div className="info">
                        <span className="date">{<LocaleFormat date={li.sent_dt} format="YYYY-MM-DD" />}</span>
                        <span className={`is-read ${li.is_read ? "read" : ""}`}>{li.is_read ? t("읽음") : t("안읽음")}</span>
                    </div>
                </div>
                <div className={`view ${isShow ? "show" : ""}`} ref={viewRef}>
                    <div className="view-inner">
                        <ParsedHtmlContent html={li.content} />
                    </div>
                </div>
            </li>
        </>
    )
}